import { sendGAEvent } from '@next/third-parties/google';

/**
 * Get Google Analytics Tracking ID
 * Note: GA_MEASUREMENT_ID is typically a build-time constant.
 * For runtime configuration, use useApi().config.GA_MEASUREMENT_ID in client components
 * or getServerRuntimeConfig().GA_MEASUREMENT_ID in server components.
 */
export function getGA_Tracking_Id(): string {
  let GA_Tracking_Id: string = process.env.GA_MEASUREMENT_ID ?? 'G-3XS3FYSNJX';

  return GA_Tracking_Id;
}

export type gaCartItem = {
  value: number;
  currency: string;
  items: gaItem[];
};

export type gaPurchase = {
  currency: string;
  value: number;
  transaction_id: string;
  items: gaItem[];
}

export type gaItem = {
  item_name: string;
  price: number;
}

export const trackAddToCart = (data: gaCartItem) => {
  sendGAEvent('event', 'add_to_cart', data);
};

export const trackPurchaseComplete = (data: gaPurchase) => {
  sendGAEvent('event', 'purchase', data);
};

export const trackCardDelivery = () => {
  sendGAEvent('event', 'send_card_button', {})
};

export const trackRemoveFromCart = (data: gaCartItem) => {
  sendGAEvent('event', 'remove_from_cart', data);
}

export const trackViewItem = (data: gaCartItem) => {
  sendGAEvent('event', 'view_item', data);
}

export const trackBeginCheckout = (data: gaCartItem) => {
  sendGAEvent('event', 'begin_checkout', data);
}

export const trackAddPaymentInfo = () => {
  sendGAEvent('event', 'add_payment_info', {});
}

export const trackLogin = () => {
  sendGAEvent('event', 'login', {
    method: 'Website'
  });
}

export const trackSearch = (search_term: string) => {
  sendGAEvent('event', 'search', {
    search_term
  });
}